import styled from 'styled-components';
import { toRem } from '../../styles';
import { MContentBlockAlignment } from './MContentBlock.types';

interface AlignmentProps {
  $alignment: MContentBlockAlignment;
}

const isCentered = ($alignment: MContentBlockAlignment) => $alignment === MContentBlockAlignment.Centered;

export const Wrapper = styled.div<AlignmentProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $alignment }) => (isCentered($alignment) ? 'center' : 'flex-start')};
  min-inline-size: 0;
  max-inline-size: 100%;
  padding: var(--general-spacer-05, ${toRem(32)});
  gap: var(--general-spacer-03, ${toRem(16)});
  border-radius: var(--t-cards-border-radius, ${toRem(14)});
  background-color: var(--t-brand-bg-color);
  box-shadow: 0 ${toRem(2)} ${toRem(10)} 0 rgba(0, 0, 0, 0.07);

  /* Let nested atoms honor global m-ellipsis-N classes against the card width. */
  .m-text-block-full {
    min-inline-size: 0;

    > * {
      inline-size: 100%;
      min-inline-size: 0;
    }
  }
`;

export const BrandWrapper = styled.div<AlignmentProps>`
  display: flex;
  justify-content: ${({ $alignment }) => (isCentered($alignment) ? 'center' : 'flex-start')};
  inline-size: 100%;
`;

export const ButtonGroup = styled.div<AlignmentProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ $alignment }) => (isCentered($alignment) ? 'center' : 'flex-start')};
  gap: var(--general-spacer-03, ${toRem(16)});
  inline-size: 100%;
`;
